import s from './BurgerMenu.module.scss';
import {TBurgerButtonProps} from "@/app/[locale]/common/components/Header/BurgerMenu/types";

export const BurgerButton = ({ isOpen, onClick }: TBurgerButtonProps) => {
    return (
        <button className={`${s.burgerButton}`} onClick={onClick}>
            <span></span>
            <span className={isOpen ? s.burgerButton_activeMiddle : ''}></span>
            <span className={isOpen ? s.burgerButton_activeLast : ''}></span>
        </button>
    );
};
